import { render, staticRenderFns } from "./ReferenceConfiguration.vue?vue&type=template&id=73f74166"
import script from "./ReferenceConfiguration.vue?vue&type=script&setup=true&lang=js"
export * from "./ReferenceConfiguration.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ReferenceConfiguration.vue?vue&type=style&index=0&id=73f74166&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports